module.exports = "/_next/static/images/id_card-1e4c599851c8f9b89e0a3ebbb7ab08d9.png";